var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React from 'react';
import classnames from 'classnames';
var EmojiFace = (function (_super) {
    __extends(EmojiFace, _super);
    function EmojiFace() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmojiFace.prototype.render = function () {
        var _a = this.props, children = _a.children, symbolReplace = _a.symbolReplace;
        var result = [];
        var hasTextAcc = false;
        var emojiCountAcc = 0;
        React.Children.forEach(children, function (child, i) {
            if (typeof child === 'string' && symbolReplace) {
                var _a = __read(symbolReplace(child, i), 3), res = _a[0], hasText = _a[1], emojiCount = _a[2];
                if (hasText)
                    hasTextAcc = true;
                emojiCountAcc += emojiCount;
                result.push.apply(result, __spread(res));
            }
            else {
                result.push(child);
            }
        });
        return (React.createElement("span", { className: classnames('emoji-face', {
                'has-text': hasTextAcc,
                'many-emoji': emojiCountAcc >= 2,
            }) }, result));
    };
    return EmojiFace;
}(React.Component));
export default EmojiFace;

//# sourceMappingURL=index.js.map
